import React from 'react';
const TreeContext = React.createContext({
    tree: 'Tree',
    treeState: {
        nodesMeta: [],
        models: null,
        inputModels: [],
        selectedNodeId: 0,
        filter: {
            status: null,
        },
    },
    adapter: null,
    plugins: [],
    models: null,
    filter: null,
    selection: null,
    onSelectionChange: null,
    hasChildren: node => false,
});
export default TreeContext;
